import React from 'react';

export default function Header() {
  return (
    <header className="site-header">
      <div className="container header-inner">
        <img src="/logo.png" alt="Adrian Galvan" width={80}/>
        <nav>
          <a href="#about">About</a>
          <a href="#skills">Skills</a>
          <a href="#experience">Experience</a>
          <a href="#projects">Projects</a>
          <a href="#contact" className="cta">
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
}
